import { Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { RowItem, TypedAGGridCellRenderParams } from "../types";

interface Props {
  params: TypedAGGridCellRenderParams<RowItem>;
}

export const CaseNameRenderer = ({ params }: Props) => {
  return (
    <>
      <Text data-testid="case-name-label" css={{ paddingTop: SPACING.SMALL }} marginBottom="xs">
        {params.value}
      </Text>
      <Text marginBottom="sm" variant="secondary-sm">
        {params.data.caseId}
      </Text>
    </>
  );
};
